import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { GridComponent } from '@progress/kendo-angular-grid';

import { MainStoreState } from '../../../_store/mainStoreState';
import { GridWrapper } from '../../../_models/GridWrapper';
import { EtapeScenario } from '../../../_models/EtapeScenario';
import { IActivationSp, ScenarioPreprogramme } from '../../../_models/ScenarioPreprogramme';
import { SpService } from '../../../_services/http/sp.service';
import { hasSessionEdition } from 'src/app/_store/SessionStore/session.store';
import { getCurrentUser } from 'src/app/_store/AccountStore/account.store';
import { DashboardService } from '../../dashboard/dashboard.service';
import { MessageService } from 'src/app/_services/local/message.service';

@Component({
  selector: 'app-sp-dialog-etape-list',
  templateUrl: './sp-dialog-etape-list.component.html',
  styleUrls: ['./sp-dialog-etape-list.component.scss'],
})
export class SpDialogEtapeListComponent implements OnInit, OnDestroy {
  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  public gridWrapper!: GridWrapper<EtapeScenario>;
  public height = document.body.clientHeight * 0.8 - (48 + 40 + 10);

  errorMessage?: string;
  spActif: boolean;
  isFormDirty = false;
  saving = false;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<MainStoreState>,
    private dialogRef: MatDialogRef<SpDialogEtapeListComponent>,
    private crudService: SpService,
    private dashboardService: DashboardService,
    private messageService: MessageService,
    @Inject(MAT_DIALOG_DATA) public data: { sp: ScenarioPreprogramme; isReadOnly: boolean }
  ) {
    this.dialogRef.disableClose = true;
    this.gridWrapper = new GridWrapper('EtapeScenario', of(this.data.sp.etapes), undefined, this.kendoGrid);

    this.spActif = this.data.sp.actif;
  }

  ngOnInit() {
    this.store.select(getCurrentUser).subscribe((user) => {
      this.store.select(hasSessionEdition(user)).subscribe((sessionEdition) => {
        if (!sessionEdition) {
          this.dashboardService.closeWidget('MapEditComponent');
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.gridWrapper.destroy();
  }

  public save(): void {
    this.errorMessage = undefined;

    const activation: IActivationSp = {
      id: this.data.sp.id,
      actif: this.data.sp.actif,
      etapes: this.data.sp.etapes.map((x) => x.formatForActivation()),
    };

    this.saving = true;

    this.crudService.activate(activation).subscribe((res) => {
      this.saving = false;

      if (res !== undefined) {
        this.dialogRef.close();
      }
    });
  }

  public toggleActif(index: number, actif: boolean) {
    if (this.spActif) {
      this.data.sp.etapes[index].actif = actif;
      this.isFormDirty = true;
    } else {
      this.messageService.info("Veuillez d'abord activer le scenario préprogrammé.");
    }
  }

  public cancelChanges(): void {
    this.dialogRef.close();
  }

  public createFormGroup(dataItem: EtapeScenario): FormGroup {
    return this.formBuilder.group({
      id: [dataItem.id],
      actif: [dataItem.actif, Validators.required],
      uuid: [dataItem.uuid, Validators.required],
      nom: [dataItem.nom],
      ordre: [dataItem.ordre],
      idSp: [dataItem.idSp],
    });
  }
}
